import { UnderlinedSectionHeader, ImgCarousel } from "@components";
import { teamImages } from "./constants";
import clsx from "clsx";

export default function WhoWeAre() {
    return (
        <>
            <UnderlinedSectionHeader>Who We Are</UnderlinedSectionHeader>
            <ImgCarousel images={teamImages} className="mt-10" />
            <div className={textContainerStyle}>
                CTrees is a U.S.-based science and technology 501(c)(3)
                nonprofit organization that has developed the first global
                system to monitor, report, and verify (MRV) carbon stocks and
                land-use activities for every ecosystem on land.
                <div className="pt-4">
                    Founded in 2022, CTrees was created by scientists to bridge
                    the gap between science and technology innovation and the
                    data needs of policy and markets. Today, our trusted,
                    independent data is used by leading governments and
                    organizations to measure the impact of programs and projects
                    worldwide.
                </div>
                <div className="pt-4">
                    CTrees is led by Sassan Saatchi, a senior research scientist
                    at NASA’s Jet Propulsion Laboratory/Caltech and adjunct
                    professor at UCLA’s Institute of the Environment and
                    Sustainability. Our team of scientists and engineers have
                    more than 20 years of experience in developing global carbon
                    and biodiversity monitoring systems that have informed
                    climate change policies.
                </div>
                <div className="pt-4">
                    We build CTrees’ science-based products by bringing together
                    experts in carbon and climate science, remote sensing,
                    tropical forest ecology, AI, and data engineering. CTrees’
                    science partners and advisors in the U.S., France, Denmark,
                    and Brazil have more than 1,000 high-impact, peer-reviewed
                    publications, and experience in developing successful REDD+
                    projects and MRV systems used by multilateral organizations,
                    development agencies, and private institutions.
                </div>
            </div>
        </>
    );
}

const textContainerStyle = clsx(
    "text-xl max-w-[800px] pt-10 p-4",
    "mb-20 lg:mb-40 text-center md:text-left",
);
